import { Action, createReducer, on } from '@ngrx/store';
import { fetchRevenueInfoFailure, fetchRevenueInfoSuccess, fetchUsersInfo, fetchUsersInfoFailure, fetchUsersInfoSuccess } from './dashboard.action';
import { fetchOverviewInfoFailure, fetchOverviewInfoSuccess } from './dashboard.action';

export interface DashboardState {
  usersInfo: any;
  revenueInfo: any;
  userInfo2: any;
  overviewInfo: any;
  activeOrderInfo: any;
  error: any;
}

export const initialState: DashboardState = {
  usersInfo: null,
  revenueInfo: null,
  userInfo2: null,
  overviewInfo: null,
  activeOrderInfo: null,
  error: null
};

export const dashboardReducer = createReducer(
  initialState,

  on(fetchUsersInfo, (state) => {
    return { ...state, error: null };
  }),
  on(fetchUsersInfoSuccess, (state, { usersInfo }) => {
    return { ...state, usersInfo };
  }),
  on(fetchUsersInfoFailure, (state, { error }) => {
    return { ...state, error };
  }),
  on(fetchRevenueInfoSuccess, (state, { revenueInfo }) => ({
    ...state,
    revenueInfo,
    error: null
  })),
  on(fetchRevenueInfoFailure, (state, { error }) => ({
    ...state,
    revenueInfo: null,
    error
  })),
  on(fetchOverviewInfoSuccess, (state, { overviewInfo }) => ({
    ...state,
    overviewInfo,
    error: null
  })),
  on(fetchOverviewInfoFailure, (state, { error }) => ({
    ...state,
    overviewInfo: null,
    error
  }))
);

// Selector
export function reducer(state: DashboardState | undefined, action: Action) {
  return dashboardReducer(state, action);
}